<router-outlet class="h-full w-full"></router-outlet>
